import { render, staticRenderFns } from "./getDriverServerFee.vue?vue&type=template&id=2934ce88&scoped=true&"
import script from "./getDriverServerFee.vue?vue&type=script&lang=js&"
export * from "./getDriverServerFee.vue?vue&type=script&lang=js&"
import style0 from "./getDriverServerFee.vue?vue&type=style&index=0&id=2934ce88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2934ce88",
  null
  
)

export default component.exports